module.exports = require("prismjs/components/prism-bash.js");